import React, { useState, useEffect } from "react";
import { PaginaCarga } from "../../../Componentes/Compuestos/Paginas/PaginaCarga";
import LVButtonAccion from "../../../Componentes/Basicos/LVButtonAccion";
import { NumberBox } from "devextreme-react";
import { LVForm } from "../../../Componentes/Basicos/LVForm";
import { SimpleItem } from "devextreme-react/form";
import { function_STK_ART_Stock_Listar } from "neftis7_apicaller/src/funciones/STK/STK_ART_Stock";
import { LVGridCabeceraReporte } from "../../../Componentes/Basicos/LVGridCabeceraReporte";
import { Column } from "devextreme-react/data-grid";
const { INV_Remitos_Cabecera: { function_INV_Remitos_Cabecera_Insertar, function_INV_Remitos_GenerarMedias_JSON, function_INV_Remitos_GenerarMediasAlquiler_JSON } } = require('neftis7_apicaller');

export const INV_Remitos_Transferencia_Medias = () => {
  const [origen, setOrigen] = useState("");
  const [destino, setDestino] = useState("");
  const [mediasS, setMediasS] = useState(0);
  const [mediasM, setMediasM] = useState(0);
  const [mediasL, setMediasL] = useState(0);

  const [resultData, setResultData] = useState([]);

  const [origenAlquiler, setOrigenAlquiler] = useState("");
  const [destinoAlquiler, setDestinoAlquiler] = useState("");
  const [mediasSAlquiler, setMediasSAlquiler] = useState(0);
  const [mediasMAlquiler, setMediasMAlquiler] = useState(0);
  const [mediasLAlquiler, setMediasLAlquiler] = useState(0);

  const handleOrigenClick = (origen) => {
    setOrigen(origen);
  };

  const handleDestinoClick = (destino) => {
    setDestino(destino);
  };

  const handleOrigenAlquilerClick = (origen) => {
    setOrigenAlquiler(origen);
  };

  const handleDestinoAlquilerClick = (destino) => {
    setDestinoAlquiler(destino);
  };

  const handleMermaClick = (destino) => {

  };

  const handleTransformacionClick = (destino) => {

  };

  const handleGuardar = async () => {
    if (origen !== null && origen !== "" && origen !== undefined) {
      if (destino !== null && destino !== "" && destino !== undefined) {
        if (mediasS === 0 && mediasM === 0 && mediasL === 0) {
          alert("Al menos una cantidad es requerida.");
        } else {
          try {
            const Remito = await function_INV_Remitos_GenerarMedias_JSON(
              localStorage.getItem("CodigoCompania"),
              localStorage.getItem("CodigoEmpresa"),
              localStorage.getItem("CodigoPlanta"),
              origen, destino,
              mediasS, mediasM, mediasL
            );

            try {
              const IdRemito = await function_INV_Remitos_Cabecera_Insertar(Remito);
              alert("Se ha creado el Remito de Transferencia");

              window.location.reload()
            } catch (error) {
              console.error("Error al guardar el Remito:", error);
              alert("Error al guardar el Remito. Por favor, intente nuevamente.");
            }
          } catch (error) {
            console.error("Error al generar el JSON del remito:", error);
            alert("Error al generar el remito. Por favor, intente nuevamente.");
          }
        }
      } else {
        alert("Destino es requerido.");
      }
    } else {
      alert("Origen es requerido.");
    }
  };

  const handleGuardarAlquiler = async () => {
    if (origenAlquiler !== null && origenAlquiler !== "" && origenAlquiler !== undefined) {
      if (destinoAlquiler !== null && destinoAlquiler !== "" && destinoAlquiler !== undefined) {
        if (mediasSAlquiler === 0 && mediasMAlquiler === 0 && mediasLAlquiler === 0) {
          alert("Al menos una cantidad es requerida.");
        } else {
          try {
            const Remito = await function_INV_Remitos_GenerarMediasAlquiler_JSON(
              localStorage.getItem("CodigoCompania"),
              localStorage.getItem("CodigoEmpresa"),
              localStorage.getItem("CodigoPlanta"),
              origenAlquiler, destinoAlquiler,
              mediasSAlquiler, mediasMAlquiler, mediasLAlquiler
            );

            try {
              const IdRemito = await function_INV_Remitos_Cabecera_Insertar(Remito);
              alert("Se ha creado el Remito de Transferencia");

              window.location.reload()
            } catch (error) {
              console.error("Error al guardar el Remito:", error);
              alert("Error al guardar el Remito. Por favor, intente nuevamente.");
            }
          } catch (error) {
            console.error("Error al generar el JSON del remito:", error);
            alert("Error al generar el remito. Por favor, intente nuevamente.");
          }
        }
      } else {
        alert("Destino es requerido.");
      }
    } else {
      alert("Origen es requerido.");
    }
  };

  const handleGetData = async () => {
    try {      
      setResultData(await function_STK_ART_Stock_Listar());
    } catch (error) {
      alert("Error al guardar el Remito:" + error);
    }
  };

  useEffect(() => {
    handleGetData()
  }, []);

  return (
    <PaginaCarga
      Titulo="MEDIAS"
    >
      <div className="LV-GroupBox-div"
        style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center'}}
      >
        <div className="LV-FlexContainer"
          style={{ marginBottom: '40px', marginTop: '10px', alignItems: 'center', gap: '10px' }}
        >
          <LVForm colCount={1} >
            <SimpleItem>
              VENTA
            </SimpleItem>
            <SimpleItem>
              <LVButtonAccion
                Texto="CENTRAL"
                Ancho={110}
                onClick={() => handleOrigenClick("DEF")}
                style={{ backgroundColor: origen === "DEF" ? "green" : "initial" }}
              />
              <LVButtonAccion
                Texto="CAJAS"
                Ancho={110}
                onClick={() => handleOrigenClick("UCTM")}
                style={{ backgroundColor: origen === "UCTM" ? "green" : "initial" }}
              />
            </SimpleItem>
            <SimpleItem>
            </SimpleItem>


            <SimpleItem>
              MEDIAS S
              <NumberBox
                value={mediasS}
                onValueChanged={(e) => setMediasS(e.value)}
                width={110}
              />
            </SimpleItem>

            <SimpleItem>
              MEDIAS M
              <NumberBox
                value={mediasM}
                onValueChanged={(e) => setMediasM(e.value)}
                width={110}
              />
            </SimpleItem>

            <SimpleItem>
              MEDIAS L
              <NumberBox
                value={mediasL}
                onValueChanged={(e) => setMediasL(e.value)}
                width={110}
              />
            </SimpleItem>

            <SimpleItem>
              <LVButtonAccion
                Texto="CENTRAL"
                Ancho={110}
                onClick={() => handleDestinoClick("DEF")}
                style={{ backgroundColor: destino === "DEF" ? "green" : "initial" }}
              />
              <LVButtonAccion
                Texto="CAJAS"
                Ancho={110}
                onClick={() => handleDestinoClick("UCTM")}
                style={{ backgroundColor: destino === "UCTM" ? "green" : "initial" }}
              />
            </SimpleItem>
            <SimpleItem>
              <LVButtonAccion
                Texto="ALQUILER"
                Ancho={110}
                onClick={() => handleTransformacionClick()}
                style={{ backgroundColor: destino === "ALQ" ? "green" : "initial" }}
              />
            </SimpleItem>

            <SimpleItem>
              <LVButtonAccion
                Texto="GUARDAR"
                Ancho={110}
                onClick={handleGuardar}
                style={{ backgroundColor: "green" }}
              />
            </SimpleItem>
          </LVForm>

          <LVForm colCount={1} >
            <SimpleItem>
              ALQUILER
            </SimpleItem>
            <SimpleItem>
              <LVButtonAccion
                Texto="ALQUILER"
                Ancho={110}
                onClick={() => handleOrigenAlquilerClick("ALQ")}
                style={{ backgroundColor: origen === "ALQ" ? "green" : "initial" }}
              />
              <LVButtonAccion
                Texto="LAVADERO"
                Ancho={110}
                onClick={() => handleOrigenAlquilerClick("LAV")}
                style={{ backgroundColor: origen === "LAV" ? "green" : "initial" }}
              />
            </SimpleItem>
            <SimpleItem>
            </SimpleItem>

            <SimpleItem>
              MEDIAS S
              <NumberBox
                value={mediasS}
                onValueChanged={(e) => setMediasSAlquiler(e.value)}
                width={110}
              />
            </SimpleItem>

            <SimpleItem>
              MEDIAS M
              <NumberBox
                value={mediasM}
                onValueChanged={(e) => setMediasMAlquiler(e.value)}
                width={110}
              />
            </SimpleItem>

            <SimpleItem>
              MEDIAS L
              <NumberBox
                value={mediasL}
                onValueChanged={(e) => setMediasLAlquiler(e.value)}
                width={110}
              />
            </SimpleItem>

            <SimpleItem>
              <LVButtonAccion
                Texto="ALQUILER"
                Ancho={110}
                onClick={() => handleDestinoAlquilerClick("ALQ")}
                style={{ backgroundColor: destino === "ALQ" ? "green" : "initial" }}
              />
              <LVButtonAccion
                Texto="LAVADERO"
                Ancho={110}
                onClick={() => handleDestinoAlquilerClick("LAV")}
                style={{ backgroundColor: destino === "LAV" ? "green" : "initial" }}
              />
            </SimpleItem>

            <SimpleItem>
              <LVButtonAccion
                Texto="MERMA"
                Ancho={110}
                onClick={() => handleMermaClick()}
                style={{ backgroundColor: destino === "LAV" ? "green" : "initial" }}
              />
            </SimpleItem>

            <SimpleItem>
              <LVButtonAccion
                Texto="GUARDAR"
                Ancho={110}
                onClick={handleGuardarAlquiler}
                style={{ backgroundColor: "green" }}
              />
            </SimpleItem>

          </LVForm>
        </div>
        <div className="LV-FlexContainer"
          style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center', gap: '100px' }}
        >
          <LVGridCabeceraReporte
            dataSource={resultData.data}>

            <Column caption="Cód." dataField="CodigoArticulo" width="70" alignment="Left" dataType="string" />
            <Column caption="Descripción" dataField="Articulo" width="100%" alignment="Left" dataType="string" />
            <Column caption="Cód." dataField="CodigoUbicacion" width="70" alignment="Left" dataType="string" visible={false} />
            <Column caption="Descripción" dataField="Ubicacion" width="120" alignment="Left" dataType="string" />
            <Column caption="Cant." dataField="CantidadActual" width="70" alignment="Right" dataType="int" />
          </LVGridCabeceraReporte>
        </div>
      </div>
    </PaginaCarga>
  );
};
